import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { BodyText } from '../../../ui';
import { PiggyBankIcon } from '../../../ui/Icons/PiggyBankIcon';

type ContactListEducationalBannerProps = {
  index: number;
  style?: object;
};

/**
 * Returns an educational banner that can live within the contacts list.
 * @param index the index in the list.
 * @param listStyle style that must be applied so it shows on the list correctly
 */
const ContactListEducationalBanner = ({
  index,
  style,
}: ContactListEducationalBannerProps) => (
  <Box
    color={colors.chill}
    borderBottomWidth={1}
    borderColor={colors.silver}
    alignItems="center"
    padding={16}
    key={`client-banner-${index}`}
    testID="inline-educational-banner"
    style={style}
  >
    <Inline alignItems="center">
      <PiggyBankIcon
        color={colors.chill}
        // @ts-ignore
        verticalAlign="middle"
        height={20}
        width={20}
      />
      <Box paddingLeft={8}>
        <BodyText
          appearance="small"
          color={colors.slate}
        >
          Clients using StyleSeat spend $90 more yearly
        </BodyText>
      </Box>
    </Inline>
  </Box>
);

export default ContactListEducationalBanner;
